import api from './api';

// Interface base para Categoria
export interface Categoria {
  id: number;
  nome: string;
  dataremocao?: string;
  principal_id?: number;
  setor_id?: number;
  idmongodb?: string;
  idmongodb_setor?: string;
}

// Interface para criação de Categoria
export interface CategoriaCreate {
  nome: string;
  principal_id?: number;
  setor_id?: number;
  idmongodb?: string;
  idmongodb_setor?: string;
}

// Interface para atualização de Categoria
export interface CategoriaUpdate {
  nome?: string;
  principal_id?: number;
  setor_id?: number;
  idmongodb?: string;
  idmongodb_setor?: string;
}

// Interface para filtros de busca
export interface CategoriaFilter {
  nome?: string;
  principal_id?: number;
  setor_id?: number;
}

const CategoriasService = {
  // Obter lista de categorias com filtragem e paginação
  getCategorias: async (filter: CategoriaFilter = {}, skip: number = 0, limit: number = 10): Promise<Categoria[]> => {
    try {
      const response = await api.get('/categorias/', {
        params: {
          ...filter,
          skip,
          limit
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
      throw error;
    }
  },

  // Obter categoria por ID
  getCategoriaById: async (id: number): Promise<Categoria> => {
    try {
      const response = await api.get(`/categorias/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar categoria ${id}:`, error);
      throw error;
    }
  },

  // Criar nova categoria
  createCategoria: async (categoria: CategoriaCreate): Promise<Categoria> => {
    try {
      const response = await api.post('/categorias/', categoria);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar categoria:', error);
      throw error;
    }
  },

  // Atualizar categoria existente
  updateCategoria: async (id: number, categoria: CategoriaUpdate): Promise<Categoria> => {
    try {
      const response = await api.put(`/categorias/${id}`, categoria);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar categoria ${id}:`, error);
      throw error;
    }
  },

  // Excluir categoria
  deleteCategoria: async (id: number): Promise<void> => {
    try {
      await api.delete(`/categorias/${id}`);
    } catch (error) {
      console.error(`Erro ao excluir categoria ${id}:`, error);
      throw error;
    }
  },

  // Obter contagem total
  getCategoriasCount: async (filter: CategoriaFilter = {}): Promise<number> => {
    try {
      const response = await api.get('/categorias/count', {
        params: filter
      });
      return response.data || 0;
    } catch (error) {
      console.error('Erro ao obter contagem de categorias:', error);
      throw error;
    }
  },

  // Obter todas as categorias (para dropdowns/selects)
  getAllCategorias: async (): Promise<Categoria[]> => {
    try {
      const response = await api.get('/categorias/all/list');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar lista de categorias:', error);
      throw error;
    }
  },

  // Obter categorias por setor
  getCategoriasBySetor: async (setorId: number): Promise<Categoria[]> => {
    try {
      const response = await api.get(`/categorias/by-setor/${setorId}`);
      return response.data || [];
    } catch (error) {
      console.error(`Erro ao buscar categorias do setor ${setorId}:`, error);
      throw error;
    }
  }
};

export default CategoriasService;
